/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DictationTask } from '../models/DictationTask';
import type { DictationTranscribeRequest } from '../models/DictationTranscribeRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DictationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Creates a transcription task and sends an event to Event Grid.
     * @returns DictationTask
     * @throws ApiError
     */
    public dictationTranscribeCreate({
        requestBody,
    }: {
        requestBody: DictationTranscribeRequest,
    }): CancelablePromise<DictationTask> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/dictation/transcribe/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Returns the status of the transcription task (fallback mechanism for WS recovery).
     * @returns DictationTask
     * @throws ApiError
     */
    public dictationTaskStatusRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<DictationTask> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/dictation/transcribe/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
